import SuccessPlanCard from "components/summary/success-plan/components/SuccessPlanCard";
import { SuccessPlanState } from "components/summary/success-plan/state/successPlan.types";
import styles from "../SuccessPlan.module.scss";
import { Typography } from "@mui/material";

type UsageSummarySectionProps = {
  spState: SuccessPlanState;
};

const UsageSummarySection = ({ spState }: UsageSummarySectionProps) => {
  const {
    spData: { extraInfo },
  } = spState;
  const {
    mtgTotMom0 = 0,
    mtgTotMom1 = 0,
    mtgTotMom = "N/A",
    mtgTotYoy = "N/A",
    mtgActiveHostsMom0 = 0,
    mtgActiveHostsMom1 = 0,
    mtgActiveHostsMom = "N/A",
    mtgActiveHostsYoy = "N/A",
    mtgAveragePerHost = 0,
    mtgVideoMon0 = 0,
    mtgVideoMon1 = 0,
    mtgVideoMom = "N/A",
    mtgVideoYoy = "N/A",
    mtgPersonalRoomMon0 = 0,
    mtgPersonalRoomMon1 = 0,
    mtgPersonalRoomMom = "N/A",
    mtgPersonalRoomYoy = "N/A",
    callDeploy = "N/A",
    callMinsMom0 = 0,
    callMinsMom1 = 0,
    callMinsMom = "N/A",
    callMinsYoy = "N/A",
    callTotMom0 = 0,
    callTotMom1 = 0,
    callTotMom = "N/A",
    callTotYoy = "N/A",
    callMauMom0 = 0,
    callMauMom1 = 0,
    callMauMom = "N/A",
    callMauYoy = "N/A",
    deviceMode = "N/A",
    // device usage
    usageMtgOther = 0,
    usageMtgZoom = 0,
    usageMtgWebex = 0,
    usageMtgGoogle = 0,
    adoptionEdge = 0,
    adoptionCloud = 0,
  } = extraInfo || {};

  return (
    <SuccessPlanCard titleSlot="Usage Summary">
      <Typography className={styles["sp-label-gray"]}>Meetings:</Typography>
      <div>
        <ul>
          <li
            className={styles["sp-label"]}
          >{`Total Meetings: ${mtgTotMom0} (vs ${mtgTotMom1} last month) - MoM: ${mtgTotMom || "N/A"} - YoY: ${mtgTotYoy || "N/A"}`}</li>
          <li
            className={styles["sp-label"]}
          >{`Active Meeting Hosts: ${mtgActiveHostsMom0} (vs ${mtgActiveHostsMom1} last month) - MoM: ${mtgActiveHostsMom || "N/A"} - YoY: ${mtgActiveHostsYoy || "N/A"}`}</li>
          <li
            className={styles["sp-label"]}
          >{`Average Meetings Per Host: ${mtgAveragePerHost}`}</li>
          <li
            className={styles["sp-label"]}
          >{`Video Meetings: ${mtgVideoMon0} (vs ${mtgVideoMon1} last month) - MoM: ${mtgVideoMom || "N/A"} - YoY: ${mtgVideoYoy || "N/A"}`}</li>
          <li
            className={styles["sp-label"]}
          >{`Personal Meeting Rooms: ${mtgPersonalRoomMon0} (vs ${mtgPersonalRoomMon1} last month) - MoM: ${mtgPersonalRoomMom || "N/A"} - YoY: ${mtgPersonalRoomYoy || "N/A"}`}</li>
        </ul>
      </div>
      <Typography className={styles["sp-label-gray"]}>Callings:</Typography>
      <div>
        <ul>
          <li
            className={styles["sp-label"]}
          >{`Primary Calling Deployment: ${callDeploy || "N/A"}`}</li>
          <li
            className={styles["sp-label"]}
          >{`Calling Minutes: ${callMinsMom0} (vs ${callMinsMom1} last month) - MoM: ${callMinsMom || "N/A"} - YoY: ${callMinsYoy || "N/A"}`}</li>
          <li
            className={styles["sp-label"]}
          >{`Total Calls: ${callTotMom0} (vs ${callTotMom1} last month) - MoM: ${callTotMom || "N/A"} - YoY: ${callTotYoy || "N/A"}`}</li>
          <li
            className={styles["sp-label"]}
          >{`Monthly Active Users (MAU): ${callMauMom0} (vs ${callMauMom1} last month) - MoM: ${callMauMom || "N/A"} - YoY: ${callMauYoy || "N/A"}`}</li>
        </ul>
      </div>
      <Typography className={styles["sp-label-gray"]}>Devices:</Typography>
      <div>
        <ul>
          <li className={styles["sp-label"]}>{`Primary Usage is ${deviceMode || "N/A"}`}</li>
          <li className={styles["sp-label"]}>{`Summarize Device Count on`}</li>
          <ul>
            <li className={styles["sp-label"]}>{`Webex: ${usageMtgWebex}`}</li>
            <li className={styles["sp-label"]}>{`Zoom: ${usageMtgZoom}`}</li>
            <li className={styles["sp-label"]}>{`Google: ${usageMtgGoogle}`}</li>
            <li className={styles["sp-label"]}>{`Other: ${usageMtgOther}`}</li>
          </ul>
          <li className={styles["sp-label"]}>{`Summarize Usage Across`}</li>
          <ul>
            <li className={styles["sp-label"]}>{`Edge: ${adoptionEdge}`}</li>
            <li className={styles["sp-label"]}>{`Cloud: ${adoptionCloud}`}</li>
          </ul>
        </ul>
      </div>
    </SuccessPlanCard>
  );
};

export default UsageSummarySection;
